import { ValidationError } from "./errors";

/** Amounts are integer minor units (cents). Never floats. */
export type Cents = number;

const CURRENCY_CODE = /^[A-Z]{3}$/;

export function assertCents(value: unknown, field: string): asserts value is Cents {
  if (typeof value !== "number" || !Number.isInteger(value) || value < 0) {
    throw new ValidationError(`${field} must be a non-negative integer amount in cents`);
  }
}

export function assertCurrency(value: unknown): asserts value is string {
  if (typeof value !== "string" || !CURRENCY_CODE.test(value)) {
    throw new ValidationError("currency must be an ISO 4217 code (e.g. MXN, USD, EUR)");
  }
}

/** Multiplies cents by a rate (e.g. 0.16) rounding half-up to the cent. */
export function applyRate(amount: Cents, rate: number): Cents {
  return Math.round(amount * rate + Number.EPSILON);
}

/** Multiplies a unit price by a quantity. Quantity may be fractional (e.g. 1.5 hours). */
export function multiply(unitPriceCents: Cents, quantity: number): Cents {
  return Math.round(unitPriceCents * quantity + Number.EPSILON);
}
